"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../common");
const TextInput_1 = require("../TextInput");
const helpers_1 = require("../../helpers");
const icons_1 = require("../../icons");
const EmptyDiv = styled_components_1.default.div `
    width: calc(2 * ${helpers_1.SPACING_L} + ${helpers_1.SPACING_XS});
    height: ${helpers_1.SPACING_L};
`;
const Box = styled_components_1.default.section `
    box-sizing: border-box;
    display: inline-flex;
    height: ${helpers_1.SIZE_XXL};
`;
const Pager = styled_components_1.default.div `
    height: ${helpers_1.SIZE_L};
    margin: 0 ${helpers_1.SPACING_S};
    padding: 0 ${helpers_1.SPACING_M};

    font-family: ${helpers_1.BASE_FONT_FAMILY};
    font-size: ${helpers_1.FONT_SIZE_M};

    display: flex;
    align-items: center;

    ${({ theme }) => (0, styled_components_1.css) `
        border-left: ${helpers_1.BASE_BORDER_WIDTH} solid ${theme.colorBorderGrid};
        border-right: ${helpers_1.BASE_BORDER_WIDTH} solid ${theme.colorBorderGrid};
    `}
`;
const Wrapper = styled_components_1.default.div `
    display: flex;
    align-items: center;

    ${common_1.PaginationButton} + ${common_1.PaginationButton} {
        margin-left: ${helpers_1.SPACING_XS};
    }

    ${Pager} {
        color: ${({ disabled, theme }) => (disabled ? theme.colorTextLight : theme.colorTextMain)};
    }
`;
const PagerInput = styled_components_1.default.div `
    width: ${({ strLength }) => `${strLength * 8 + 22}px`};
    margin: 0 ${helpers_1.SPACING_S};
    position: relative;

    [data-text-input='true'] {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
`;
exports.Pagination = (0, helpers_1.createUIElement)('Pagination', (_a, ref) => {
    var { className, disabled = false, activePage = 1, lastPage, hasEnterKeyStopPropagation = true, onPageChange, onPageClick, texts, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "disabled", "activePage", "lastPage", "hasEnterKeyStopPropagation", "onPageChange", "onPageClick", "texts", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const inputRef = (0, react_1.useRef)(null);
    const { getValue, setValue } = (0, helpers_1.useStateValue)(activePage, [activePage]);
    const isNum = new RegExp(/^\d+$/);
    const rewindButtonHandleClick = () => !disabled && (onPageClick === null || onPageClick === void 0 ? void 0 : onPageClick(1));
    const previousButtonHandleClick = () => activePage > 1 && !disabled && (onPageClick === null || onPageClick === void 0 ? void 0 : onPageClick(activePage - 1));
    const nextButtonHandleClick = () => activePage < lastPage && !disabled && (onPageClick === null || onPageClick === void 0 ? void 0 : onPageClick(activePage + 1));
    const forwardButtonHandleClick = () => !disabled && (onPageClick === null || onPageClick === void 0 ? void 0 : onPageClick(lastPage));
    const changePage = (value) => {
        if (!disabled && value <= lastPage && value > 0) {
            setValue(value);
        }
    };
    const handleBlur = () => {
        const value = getValue();
        if (value === 0) {
            setValue(activePage);
        }
        if (value !== 0 && value !== activePage) {
            changePage(value);
            onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(value);
        }
    };
    const handleChange = (value) => {
        if (!value.length) {
            setValue(0);
        }
        if (value.length && isNum.test(value)) {
            changePage(parseInt(value, 10));
        }
    };
    const value = getValue();
    (0, react_1.useEffect)(() => {
        setValue(activePage);
    }, [activePage]);
    return (react_1.default.createElement(Box, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: `vm-Pagination ${className}`, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(Wrapper, { disabled: disabled },
            activePage <= 1 && react_1.default.createElement(EmptyDiv, null),
            activePage > 1 && (react_1.default.createElement(common_1.PaginationButton, { "data-selector-id": "pagination-rewind-button", onClick: rewindButtonHandleClick, disabled: disabled },
                react_1.default.createElement(icons_1.RewindIcon, null))),
            activePage > 1 && (react_1.default.createElement(common_1.PaginationButton, { "data-selector-id": "pagination-previous-button", onClick: previousButtonHandleClick, disabled: disabled },
                react_1.default.createElement(icons_1.PreviousIcon, null))),
            react_1.default.createElement(Pager, null,
                react_1.default.createElement("span", null, (texts === null || texts === void 0 ? void 0 : texts.page) || 'Page'),
                react_1.default.createElement(PagerInput, { strLength: value.toString().length },
                    react_1.default.createElement("form", { "data-selector-id": "pagination-form", onSubmit: (e) => {
                            var _a;
                            e.preventDefault();
                            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                        } },
                        react_1.default.createElement(TextInput_1.TextInput, { controlRef: inputRef, value: String(value === 0 ? '' : value), onBlur: handleBlur, onChange: handleChange, disabled: disabled, size: common_1.CONTROL_SIZE.full, hasEnterKeyStopPropagation: hasEnterKeyStopPropagation }))),
                react_1.default.createElement("span", null,
                    (texts === null || texts === void 0 ? void 0 : texts.of) || 'of',
                    " ",
                    lastPage)),
            activePage < lastPage && (react_1.default.createElement(common_1.PaginationButton, { "data-selector-id": "pagination-next-button", onClick: nextButtonHandleClick, disabled: disabled },
                react_1.default.createElement(icons_1.NextIcon, null))),
            activePage < lastPage && (react_1.default.createElement(common_1.PaginationButton, { "data-selector-id": "pagination-forward-button", onClick: forwardButtonHandleClick, disabled: disabled },
                react_1.default.createElement(icons_1.ForwardIcon, null))),
            activePage >= lastPage && react_1.default.createElement(EmptyDiv, null))));
});
//# sourceMappingURL=Pagination.js.map